// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25lxg","content":"styles_content__2oM7r"};